// extracted by mini-css-extract-plugin
module.exports = {"root":"GobackButton_root__3kJFN"};